/* Napa Kit Builder - Priority Experiences */
(function () {
  'use strict';

  /* STEP ORDER
     This array, the crumbs list in sections/pe-napa-kit-builder.liquid, and the
     order of the <section data-napa-step> blocks must all match. A crumb's
     index is mapped straight into STEPS, so changing one without the others
     sends people to the wrong step. */
  var STEPS = ['box', 'crinkle', 'contents', 'ribbon', 'finishing', 'personalize', 'delivery', 'contact', 'review'];
  var SINGLE_ROLES = ['box', 'crinkle', 'ribbon'];
  var SCHEMA = 6;

  /* Colours come from admin colour fields, but they are still untrusted input
     being written into a style attribute. Only plain hex gets through. */
  var HEX = /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

  function money(n, symbol) { return symbol + (Math.round(n * 100) / 100).toFixed(2); }
  function round2(n) { return Math.round(n * 100) / 100; }
  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }

  function parseJSON(el, fallback) {
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { console.error('[napa-kit] bad JSON', e); return fallback; }
  }

  function todayIn(tz) {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    } catch (e) { return null; }
  }

  function addDays(iso, days) {
    var p = String(iso).split('-');
    if (p.length !== 3) return null;
    var d = new Date(Date.UTC(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10)));
    if (isNaN(d.getTime())) return null;
    d.setUTCDate(d.getUTCDate() + days);
    return d.toISOString().slice(0, 10);
  }

  function humanDate(iso) {
    var p = String(iso).split('-');
    if (p.length !== 3) return iso;
    var d = new Date(Date.UTC(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10)));
    if (isNaN(d.getTime())) return iso;
    try {
      return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }).format(d);
    } catch (e) { return iso; }
  }

  var tipSeq = 0;

  function NapaKit(root) {
    this.root = root;
    this.symbol = root.dataset.currencySymbol || '$';
    this.endpoint = root.dataset.endpoint || '';
    this.fallbackEmail = root.dataset.fallbackEmail || '';
    this.minKits = parseInt(root.dataset.minKits, 10) || 1;
    this.basePrice = parseFloat(root.dataset.basePrice) || 0;
    this.baseLabel = root.dataset.baseLabel || 'Base kit';
    this.subtotalLabel = root.dataset.subtotalLabel || 'Kits subtotal';
    this.timezone = root.dataset.timezone || 'America/Los_Angeles';
    this.leadDays = parseInt(root.dataset.leadDays, 10);
    if (isNaN(this.leadDays) || this.leadDays < 0) this.leadDays = 14;
    this.storageKey = root.dataset.storageKey || 'napa-kit';
    this.storageDays = parseInt(root.dataset.storageDays, 10);
    if (isNaN(this.storageDays)) this.storageDays = 14;

    this.addons = parseJSON(root.querySelector('[data-napa-addons]'), []);
    this.options = parseJSON(root.querySelector('[data-napa-options]'), { box: [], crinkle: [], ribbon: [], finishing: [] });
    this.fees = parseJSON(root.querySelector('[data-napa-fees]'), []);

    this.earliestDate = this.computeEarliest(root.dataset.earliestDate);

    this.state = this.blankState();
    this.index = 0;
    this.visited = { box: true };
    this.firstRender = true;

    this.restore();
    this.bind();
    this.applyDateLimit();
    this.syncInputs();
    this.render();
  }

  /* ---------- dates ---------- */

  NapaKit.prototype.computeEarliest = function (fromLiquid) {
    var today = todayIn(this.timezone);
    var fromBrowser = today ? addDays(today, this.leadDays) : null;
    var candidates = [fromLiquid, fromBrowser].filter(function (d) {
      return typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d);
    });
    if (!candidates.length) return null;
    return candidates.sort()[candidates.length - 1];
  };

  NapaKit.prototype.applyDateLimit = function () {
    if (!this.earliestDate) return;
    var input = this.root.querySelector('[data-napa-field="delivery.shipDate"]');
    if (input) input.min = this.earliestDate;
  };

  NapaKit.prototype.dateTooSoon = function (value) {
    if (!value || !this.earliestDate) return false;
    return value < this.earliestDate;
  };

  NapaKit.prototype.blankState = function () {
    return {
      kits: this.minKits,
      box: null,
      contents: {},
      crinkle: null,
      ribbon: null,
      finishing: {},
      personalize: { message: '', recipientName: '', notes: '' },
      delivery: { shipDate: '', address: '', notes: '' },
      contact: { name: '', company: '', email: '', phone: '' }
    };
  };

  /* ---------- persistence ---------- */

  NapaKit.prototype.storageAvailable = function () {
    if (this.storageDays <= 0) return false;
    try {
      window.localStorage.setItem('__nk_test__', '1');
      window.localStorage.removeItem('__nk_test__');
      return true;
    } catch (e) { return false; }
  };

  NapaKit.prototype.save = function () {
    if (!this.storageAvailable()) return;
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify({
        schema: SCHEMA, savedAt: Date.now(), index: this.index, visited: this.visited, state: this.state
      }));
    } catch (e) { console.warn('[napa-kit] could not save progress', e); }
  };

  NapaKit.prototype.clearSaved = function () {
    if (!this.storageAvailable()) return;
    try { window.localStorage.removeItem(this.storageKey); } catch (e) {}
  };

  NapaKit.prototype.restore = function () {
    if (!this.storageAvailable()) return;

    var raw;
    try { raw = window.localStorage.getItem(this.storageKey); } catch (e) { return; }
    if (!raw) return;

    var saved;
    try { saved = JSON.parse(raw); } catch (e) { this.clearSaved(); return; }
    if (!saved || saved.schema !== SCHEMA || !saved.state) { this.clearSaved(); return; }

    var ageDays = (Date.now() - (saved.savedAt || 0)) / 86400000;
    if (ageDays > this.storageDays) { this.clearSaved(); return; }

    var self = this;
    var next = this.blankState();
    var dropped = 0;
    var clamped = false;
    var s = saved.state;

    SINGLE_ROLES.forEach(function (role) {
      var id = s[role];
      if (!id) return;
      if (self.optionById(role, id)) next[role] = id;
      else dropped++;
    });

    if (s.finishing) {
      Object.keys(s.finishing).forEach(function (id) {
        if (!s.finishing[id]) return;
        if (self.optionById('finishing', id)) next.finishing[id] = true;
        else dropped++;
      });
    }

    if (s.contents) {
      Object.keys(s.contents).forEach(function (lineId) {
        var line = s.contents[lineId];
        var found = self.lineById(lineId);
        if (!found || !line || !line.qty) { dropped++; return; }
        var qty = Math.max(0, parseInt(line.qty, 10) || 0);
        var cap = self.maxFor(found.addon);
        if (cap > 0 && qty > cap) { qty = cap; clamped = true; }
        if (qty < 1) { dropped++; return; }
        next.contents[lineId] = self.buildLine(found, qty);
      });
    }

    ['personalize', 'delivery', 'contact'].forEach(function (group) {
      if (!s[group]) return;
      Object.keys(next[group]).forEach(function (field) {
        if (typeof s[group][field] === 'string') next[group][field] = s[group][field];
      });
    });

    var staleDate = false;
    if (next.delivery.shipDate && this.dateTooSoon(next.delivery.shipDate)) {
      next.delivery.shipDate = '';
      staleDate = true;
    }

    var kits = parseInt(s.kits, 10);
    next.kits = isNaN(kits) ? this.minKits : Math.max(this.minKits, kits);

    this.state = next;
    this.visited = saved.visited && typeof saved.visited === 'object' ? saved.visited : { box: true };
    var idx = parseInt(saved.index, 10);
    this.index = isNaN(idx) || idx < 0 || idx >= STEPS.length ? 0 : idx;

    this.announceRestore(dropped, staleDate, clamped);
  };

  NapaKit.prototype.announceRestore = function (dropped, staleDate, clamped) {
    var banner = this.root.querySelector('[data-napa-restored]');
    if (!banner) return;
    var text = banner.querySelector('[data-napa-restored-text]');
    var msg = 'We brought back the kit you were building.';
    if (dropped > 0) msg += ' ' + plural(dropped, 'option') + ' you had picked is no longer available, so please check your selections.';
    if (clamped) msg += ' One of your items now has a lower limit per kit, so the quantity was reduced.';
    if (staleDate) msg += ' Your delivery date is now inside our ' + plural(this.leadDays, 'day') + ' lead time, so please pick a new one.';
    if (text) text.textContent = msg;
    banner.hidden = false;
    banner.classList.toggle('is-warning', dropped > 0 || staleDate || clamped);
  };

  NapaKit.prototype.reset = function () {
    this.clearSaved();
    this.state = this.blankState();
    this.visited = { box: true };
    this.index = 0;
    var banner = this.root.querySelector('[data-napa-restored]');
    if (banner) banner.hidden = true;
    this.syncInputs();
    this.showError(null);
    this.render();
  };

  NapaKit.prototype.syncInputs = function () {
    var self = this;
    this.root.querySelectorAll('[data-napa-field]').forEach(function (el) {
      var path = el.dataset.napaField.split('.');
      var val = self.state[path[0]] ? self.state[path[0]][path[1]] : '';
      if (typeof val === 'string') el.value = val;
    });
    var kits = this.root.querySelector('[data-napa-kits]');
    if (kits) kits.value = this.state.kits;
  };

  /* ---------- lookups ---------- */

  NapaKit.prototype.choicesFor = function (role) { return this.options[role] || []; };

  NapaKit.prototype.optionById = function (role, id) {
    var list = this.choicesFor(role);
    for (var i = 0; i < list.length; i++) { if (String(list[i].id) === String(id)) return list[i]; }
    return null;
  };

  NapaKit.prototype.addonByHandle = function (handle) {
    for (var i = 0; i < this.addons.length; i++) {
      if (this.addons[i].id === handle) return this.addons[i];
    }
    return null;
  };

  NapaKit.prototype.lineById = function (lineId) {
    for (var i = 0; i < this.addons.length; i++) {
      var vs = this.addons[i].variants || [];
      for (var j = 0; j < vs.length; j++) {
        if (String(vs[j].id) === String(lineId)) return { addon: this.addons[i], variant: vs[j] };
      }
    }
    return null;
  };

  NapaKit.prototype.buildLine = function (found, qty) {
    var v = found.variant;
    var slots = parseInt(v.slots, 10);
    if (isNaN(slots) || slots < 0) slots = 1;
    return {
      qty: qty,
      price: parseFloat(v.price) || 0,
      slots: slots,
      title: found.addon.title,
      variantTitle: v.title || '',
      addonHandle: found.addon.id,
      productId: found.addon.productId || null,
      variantId: String(v.id).indexOf('flat:') === 0 ? null : v.id,
      lineId: v.id
    };
  };

  /* ---------- per-item limits ---------- */

  NapaKit.prototype.maxFor = function (addon) {
    if (!addon) return 1;
    var m = parseInt(addon.maxPerKit, 10);
    if (isNaN(m) || m < 0) return 1;
    return m;
  };

  NapaKit.prototype.linesForAddon = function (handle) {
    var self = this;
    return Object.keys(this.state.contents).filter(function (k) {
      return self.state.contents[k].addonHandle === handle;
    });
  };

  NapaKit.prototype.qtyForAddon = function (handle) {
    var self = this;
    return this.linesForAddon(handle).reduce(function (sum, k) {
      return sum + self.state.contents[k].qty;
    }, 0);
  };

  NapaKit.prototype.atMax = function (addon) {
    var cap = this.maxFor(addon);
    if (cap === 0) return false;
    return this.qtyForAddon(addon.id) >= cap;
  };

  /* ---------- capacity ---------- */

  NapaKit.prototype.capacity = function () {
    var box = this.state.box ? this.optionById('box', this.state.box) : null;
    var c = box && box.capacity ? parseInt(box.capacity, 10) : 0;
    return c > 0 ? c : 0;
  };

  NapaKit.prototype.usedSlots = function () {
    var self = this;
    return Object.keys(this.state.contents).reduce(function (sum, k) {
      var e = self.state.contents[k];
      return sum + (e.slots || 1) * e.qty;
    }, 0);
  };

  NapaKit.prototype.slotsFor = function (lineId) {
    var found = this.lineById(lineId);
    if (!found) return 1;
    var s = parseInt(found.variant.slots, 10);
    return isNaN(s) || s < 0 ? 1 : s;
  };

  NapaKit.prototype.roomFor = function (lineId) {
    var cap = this.capacity();
    if (cap === 0) return true;
    return this.usedSlots() + this.slotsFor(lineId) <= cap;
  };

  /* ---------- gift message ---------- */

  NapaKit.prototype.messageOptions = function () {
    var self = this;
    return Object.keys(this.state.finishing).filter(function (k) {
      if (!self.state.finishing[k]) return false;
      var o = self.optionById('finishing', k);
      return o && o.requiresMessage;
    }).map(function (k) { return self.optionById('finishing', k); });
  };

  NapaKit.prototype.needsMessage = function () { return this.messageOptions().length > 0; };

  /* ==================================================================
     PRICING
     1. Per-kit lines, including any fee charged Per kit.
     2. Kits subtotal = per-kit total x quantity.
     3. Per-order fees added once.
     4. Percentage fees on (kits subtotal + per-order fees), never on
        each other.
     ================================================================== */

  /* PRICE IS PRICE.
     This used to return 0 for anything tiered Standard, so a Standard box with
     a real price quietly charged nothing while its card read "Included". That
     shipped, and it under-quoted every kit using a paid standard box. Tier now
     only drives the Seasonal badge; 0 or blank is what makes something free.
     Do not reintroduce a tier check here. */
  NapaKit.prototype.surcharge = function (option) {
    if (!option) return 0;
    return parseFloat(option.price) || 0;
  };

  NapaKit.prototype.activeFees = function (basis) {
    var kits = this.state.kits;
    return this.fees.filter(function (f) {
      if (f.basis !== basis) return false;
      var max = parseInt(f.maxKits, 10);
      if (!isNaN(max) && max > 0 && kits >= max) return false;
      return (parseFloat(f.amount) || 0) !== 0;
    });
  };

  NapaKit.prototype.lines = function () {
    var self = this;
    var out = [];

    if (this.basePrice > 0) out.push({ label: this.baseLabel, amount: this.basePrice, base: true });

    if (this.state.box) {
      var b = this.optionById('box', this.state.box);
      if (b) out.push({ label: b.label, amount: this.surcharge(b) });
    }

    if (this.state.crinkle) {
      var c = this.optionById('crinkle', this.state.crinkle);
      if (c) out.push({ label: c.label + ' crinkle', amount: this.surcharge(c) });
    }

    Object.keys(this.state.contents).forEach(function (lineId) {
      var e = self.state.contents[lineId];
      if (!e || e.qty < 1) return;
      var suffix = e.variantTitle && e.variantTitle !== 'Default Title' ? ' - ' + e.variantTitle : '';
      out.push({ label: e.title + suffix + (e.qty > 1 ? ' x' + e.qty : ''), amount: e.price * e.qty });
    });

    if (this.state.ribbon) {
      var r = this.optionById('ribbon', this.state.ribbon);
      if (r) out.push({ label: r.label + ' ribbon', amount: this.surcharge(r) });
    }

    Object.keys(this.state.finishing).forEach(function (id) {
      if (!self.state.finishing[id]) return;
      var f = self.optionById('finishing', id);
      if (f) out.push({ label: f.label, amount: self.surcharge(f) });
    });

    this.activeFees('Per kit').forEach(function (f) {
      out.push({ label: f.label, amount: parseFloat(f.amount) || 0, fee: true, description: f.description || '' });
    });

    return out;
  };

  NapaKit.prototype.perKit = function () {
    return this.lines().reduce(function (sum, l) { return sum + l.amount; }, 0);
  };

  NapaKit.prototype.kitsSubtotal = function () { return this.perKit() * this.state.kits; };

  NapaKit.prototype.orderFeeLines = function () {
    var out = [];
    this.activeFees('Per order').forEach(function (f) {
      out.push({ handle: f.id, label: f.label, description: f.description || '', basis: 'Per order', rate: null, amount: round2(parseFloat(f.amount) || 0) });
    });
    var pctBase = this.kitsSubtotal() + out.reduce(function (s, l) { return s + l.amount; }, 0);
    this.activeFees('Percentage').forEach(function (f) {
      var pct = parseFloat(f.amount) || 0;
      out.push({ handle: f.id, label: f.label, description: f.description || '', basis: 'Percentage', rate: pct, amount: round2(pctBase * (pct / 100)) });
    });
    return out;
  };

  NapaKit.prototype.total = function () {
    return this.kitsSubtotal() + this.orderFeeLines().reduce(function (s, l) { return s + l.amount; }, 0);
  };

  /* ---------- validation ---------- */

  NapaKit.prototype.validate = function (step) {
    var s = this.state;
    switch (step) {
      case 'box':
        if (this.choicesFor('box').length === 0) return null;
        return s.box ? null : 'Choose a box to continue.';
      case 'crinkle':
        if (this.choicesFor('crinkle').length === 0) return null;
        return s.crinkle ? null : 'Choose a crinkle fill color to continue.';
      case 'contents':
        var picked = Object.keys(s.contents).some(function (k) { return s.contents[k].qty > 0; });
        if (!picked) return 'Add at least one item to the kit.';
        var cap = this.capacity();
        if (cap > 0 && this.usedSlots() > cap) {
          var box = this.optionById('box', s.box);
          return 'The ' + box.label + ' holds ' + plural(cap, 'slot') + '. You have used ' + this.usedSlots() + '. Remove something or choose a larger box.';
        }
        return null;
      case 'ribbon':
        if (this.choicesFor('ribbon').length === 0) return null;
        return s.ribbon ? null : 'Choose a ribbon color to continue.';
      case 'finishing':
        return null;
      case 'personalize':
        if (this.needsMessage() && !s.personalize.message.trim()) {
          return 'You added ' + this.messageOptions()[0].label + ', which carries a printed message. Add the wording to continue.';
        }
        return null;
      case 'delivery':
        if (!s.delivery.shipDate) return 'Tell us when the kits need to arrive.';
        if (this.dateTooSoon(s.delivery.shipDate)) {
          return 'We need at least ' + plural(this.leadDays, 'day') + '. The earliest we can deliver is ' + humanDate(this.earliestDate) + '.';
        }
        if (!s.delivery.address.trim()) return 'Add the Napa delivery address.';
        return null;
      case 'contact':
        if (!s.contact.name.trim()) return 'Your name is required.';
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(s.contact.email)) return 'Enter a valid email address.';
        return null;
      default:
        return null;
    }
  };

  /* ---------- navigation ---------- */

  NapaKit.prototype.goTo = function (i) {
    if (i < 0 || i >= STEPS.length) return;
    this.index = i;
    this.visited[STEPS[i]] = true;
    this.render();
    var head = this.root.querySelector('.napa-kit__progress');
    if (head) head.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  NapaKit.prototype.next = function () {
    var err = this.validate(STEPS[this.index]);
    this.showError(err);
    if (err) return;
    this.goTo(this.index + 1);
  };

  NapaKit.prototype.showError = function (msg, action) {
    var box = this.root.querySelector('[data-napa-error]');
    if (!box) return;
    box.textContent = '';
    if (msg) {
      box.appendChild(document.createTextNode(msg));
      if (action && action.addon && action.label) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'napa-kit__error-action';
        btn.setAttribute('data-napa-error-action', action.addon);
        btn.textContent = action.label;
        box.appendChild(btn);
      }
    }
    box.classList.toggle('is-visible', !!msg);
  };

  NapaKit.prototype.removeAddonLines = function (handle) {
    var self = this;
    this.linesForAddon(handle).forEach(function (k) { delete self.state.contents[k]; });
    this.showError(null);
    this.render();
  };

  /* ---------- fee tooltips ---------- */

  NapaKit.prototype.closeTips = function (except) {
    this.root.querySelectorAll('[data-napa-tip].is-open').forEach(function (tip) {
      if (tip === except) return;
      tip.classList.remove('is-open');
      var btn = tip.parentNode.querySelector('[data-napa-info]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  };

  NapaKit.prototype.fillLabelCell = function (cell, text, description) {
    cell.textContent = '';
    cell.appendChild(document.createTextNode(text));
    if (!description) return null;

    tipSeq += 1;
    var tipId = 'nk-tip-' + tipSeq;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'napa-kit__info';
    btn.setAttribute('data-napa-info', '');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-describedby', tipId);
    btn.setAttribute('aria-label', 'About ' + text);
    btn.textContent = 'i';
    cell.appendChild(btn);

    var tip = document.createElement('span');
    tip.className = 'napa-kit__tip';
    tip.id = tipId;
    tip.setAttribute('role', 'tooltip');
    tip.setAttribute('data-napa-tip', '');
    tip.textContent = description;
    return tip;
  };

  /* ---------- events ---------- */

  NapaKit.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      var t = e.target;

      var errAction = t.closest('[data-napa-error-action]');
      if (errAction) { self.removeAddonLines(errAction.getAttribute('data-napa-error-action')); return; }

      var info = t.closest('[data-napa-info]');
      if (info) {
        var row = info.closest('li');
        var tip = row ? row.querySelector('[data-napa-tip]') : null;
        if (tip) {
          var open = tip.classList.toggle('is-open');
          info.setAttribute('aria-expanded', open ? 'true' : 'false');
          self.closeTips(tip);
        }
        return;
      }
      self.closeTips(null);

      if (t.closest('[data-napa-reset]')) { self.reset(); return; }

      var crumb = t.closest('[data-napa-crumb]');
      if (crumb) { self.goTo(parseInt(crumb.dataset.napaCrumb, 10)); return; }

      var nav = t.closest('[data-napa-nav]');
      if (nav) {
        if (nav.dataset.napaNav === 'next') self.next();
        else self.goTo(self.index - 1);
        return;
      }

      var edit = t.closest('[data-napa-edit]');
      if (edit) { self.goTo(STEPS.indexOf(edit.dataset.napaEdit)); return; }

      var pick = t.closest('[data-napa-pick]');
      if (pick) {
        var role = pick.dataset.napaRole;
        var id = pick.dataset.napaPick;
        if (SINGLE_ROLES.indexOf(role) !== -1) self.state[role] = self.state[role] === id ? null : id;
        else self.state.finishing[id] = !self.state.finishing[id];
        self.showError(null);
        self.render();
        return;
      }

      var qty = t.closest('[data-napa-qty]');
      if (qty) {
        var qCard = qty.closest('[data-napa-addon]');
        if (qCard) self.changeQty(self.lineIdFor(qCard), qty.dataset.napaQty === 'up' ? 1 : -1);
        return;
      }

      var toggle = t.closest('[data-napa-toggle]');
      if (toggle) {
        var tCard = toggle.closest('[data-napa-addon]');
        if (tCard) self.toggleSingle(self.lineIdFor(tCard));
        return;
      }

      if (t.closest('[data-napa-submit]')) { self.submit(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeTips(null);
    });

    this.root.addEventListener('change', function (e) {
      var field = e.target.closest('[data-napa-field]');
      if (field) {
        var path = field.dataset.napaField.split('.');
        self.state[path[0]][path[1]] = field.value;
        if (path[1] === 'shipDate') {
          self.showError(self.dateTooSoon(field.value)
            ? 'We need at least ' + plural(self.leadDays, 'day') + '. The earliest we can deliver is ' + humanDate(self.earliestDate) + '.'
            : null);
        }
        self.save();
        return;
      }
      var kits = e.target.closest('[data-napa-kits]');
      if (kits) {
        self.state.kits = Math.max(self.minKits, parseInt(kits.value, 10) || self.minKits);
        kits.value = self.state.kits;
        self.renderSummary();
        self.save();
        return;
      }
      var variantSel = e.target.closest('[data-napa-variant]');
      if (variantSel) {
        var vCard = variantSel.closest('[data-napa-addon]');
        if (vCard) self.swapVariant(vCard, variantSel.value);
        self.render();
      }
    });

    this.root.addEventListener('input', function (e) {
      var field = e.target.closest('[data-napa-field]');
      if (!field) return;
      var path = field.dataset.napaField.split('.');
      self.state[path[0]][path[1]] = field.value;
      clearTimeout(self._saveTimer);
      self._saveTimer = setTimeout(function () { self.save(); }, 400);
    });
  };

  /* One per kit plus size options is a CHOICE, not a quantity cap. If the item
     is already in the kit and the customer picks a different size, move the
     selection rather than leaving them stuck: the card's Remove control only
     ever belongs to the size currently showing, so without this there is no
     way to get rid of the size they no longer want. */
  NapaKit.prototype.swapVariant = function (card, newLineId) {
    var self = this;
    var addon = this.addonByHandle(card.dataset.napaAddon);
    if (!addon || this.maxFor(addon) !== 1) return;

    var existing = this.linesForAddon(addon.id);
    if (!existing.length || existing.indexOf(newLineId) !== -1) return;

    var found = this.lineById(newLineId);
    if (!found) return;

    var kept = existing.map(function (k) { return { key: k, line: self.state.contents[k] }; });
    var qty = kept[0].line.qty;
    kept.forEach(function (e) { delete self.state.contents[e.key]; });

    if (this.roomFor(newLineId)) {
      this.state.contents[newLineId] = this.buildLine(found, qty);
      this.showError(null);
    } else {
      kept.forEach(function (e) { self.state.contents[e.key] = e.line; });
      this.showError(this.roomMessage(newLineId));
    }
  };

  NapaKit.prototype.toggleEl = function (card) {
    if (card.matches && card.matches('[data-napa-toggle]')) return card;
    return card.querySelector('[data-napa-toggle]');
  };

  NapaKit.prototype.lineIdFor = function (card) {
    var sel = card.querySelector('[data-napa-variant]');
    if (sel) return sel.value;
    var addon = this.addonByHandle(card.dataset.napaAddon);
    return addon && addon.variants.length ? addon.variants[0].id : null;
  };

  NapaKit.prototype.toggleSingle = function (lineId) {
    if (!lineId) return;
    if (this.state.contents[lineId]) {
      delete this.state.contents[lineId];
      this.showError(null);
      this.render();
      return;
    }
    this.changeQty(lineId, 1);
  };

  NapaKit.prototype.limitMessage = function (addon) {
    var cap = this.maxFor(addon);
    var lines = this.linesForAddon(addon.id);
    var inKit = lines.length === 1 ? this.state.contents[lines[0]] : null;
    var which = inKit && inKit.variantTitle ? addon.title + ' (' + inKit.variantTitle + ')' : addon.title;

    if (cap === 1) return which + ' is already in your kit, and only one is allowed per kit.';
    return 'You can add up to ' + cap + ' of ' + addon.title + ' per kit, and you have reached that.';
  };

  NapaKit.prototype.roomMessage = function (lineId) {
    var box = this.optionById('box', this.state.box);
    var left = this.capacity() - this.usedSlots();
    return 'That would need ' + plural(this.slotsFor(lineId), 'slot') + ' and the ' +
      (box ? box.label : 'box') + ' only has ' + left + ' left. Choose a larger box or remove something.';
  };

  NapaKit.prototype.changeQty = function (lineId, delta) {
    if (!lineId) return;
    var found = this.lineById(lineId);
    if (!found) return;

    if (delta > 0) {
      if (this.atMax(found.addon)) {
        this.showError(this.limitMessage(found.addon), {
          addon: found.addon.id,
          label: 'Remove it from the kit'
        });
        return;
      }
      if (!this.roomFor(lineId)) { this.showError(this.roomMessage(lineId)); return; }
    }

    var existing = this.state.contents[lineId];
    var qty = (existing ? existing.qty : 0) + delta;
    if (qty <= 0) delete this.state.contents[lineId];
    else this.state.contents[lineId] = this.buildLine(found, qty);

    this.showError(null);
    this.render();
  };

  /* ---------- rendering ---------- */

  NapaKit.prototype.render = function () {
    var self = this;
    var current = STEPS[this.index];

    this.root.querySelectorAll('[data-napa-step]').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.napaStep === current);
    });

    this.root.querySelectorAll('[data-napa-crumb]').forEach(function (el) {
      var i = parseInt(el.dataset.napaCrumb, 10);
      var name = STEPS[i];
      el.setAttribute('aria-current', i === self.index ? 'step' : 'false');
      el.dataset.visited = self.visited[name] ? 'true' : 'false';
      el.dataset.complete = self.visited[name] && self.validate(name) === null && i !== self.index ? 'true' : 'false';
    });

    this.root.querySelectorAll('[data-napa-pick]').forEach(function (el) {
      var role = el.dataset.napaRole;
      var id = el.dataset.napaPick;
      var on = SINGLE_ROLES.indexOf(role) !== -1 ? self.state[role] === id : !!self.state.finishing[id];
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var cap = this.capacity();
    var used = this.usedSlots();

    this.root.querySelectorAll('[data-napa-addon]').forEach(function (card) {
      var addon = self.addonByHandle(card.dataset.napaAddon);
      var lineId = self.lineIdFor(card);
      var entry = lineId ? self.state.contents[lineId] : null;
      var slots = lineId ? self.slotsFor(lineId) : 1;
      var on = !!entry;
      var noRoom = cap > 0 && used + slots > cap;

      /* Only worth saying when an item is bigger than the default. When every
         item is 1 slot this line is identical on every card, so it reads as
         decoration and costs a row of height across the whole grid. */
      var note = card.querySelector('[data-napa-slot-note]');
      if (note) note.textContent = slots > 1 ? 'Takes ' + slots + ' slots' : '';

      var toggle = self.toggleEl(card);
      if (toggle) {
        toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
        toggle.classList.toggle('is-on', on);
        var label = toggle.querySelector('[data-napa-toggle-label]') || card.querySelector('[data-napa-toggle-label]');
        if (label) label.textContent = on ? 'Remove' : 'Add';
        if (toggle.tagName === 'BUTTON') {
          toggle.disabled = !on && noRoom;
          toggle.title = !on && noRoom ? 'Not enough room left in this box' : '';
        }
        card.classList.toggle('is-blocked', !on && noRoom);
      }

      var out = card.querySelector('output');
      if (out) out.textContent = entry ? entry.qty : 0;

      var minus = card.querySelector('[data-napa-qty="down"]');
      if (minus) minus.disabled = !entry || entry.qty === 0;

      var plus = card.querySelector('[data-napa-qty="up"]');
      if (plus) {
        var maxed = addon ? self.atMax(addon) : false;
        plus.disabled = maxed || noRoom;
        plus.title = maxed
          ? 'Limit of ' + self.maxFor(addon) + ' per kit'
          : (noRoom ? 'Not enough room left in this box' : '');
      }

      card.classList.toggle('is-selected', on);
    });

    this.renderGroups();
    this.renderMeter(cap, used);
    this.renderMessageField();

    var back = this.root.querySelector('[data-napa-nav="back"]');
    if (back) back.style.visibility = this.index === 0 ? 'hidden' : 'visible';
    var nextBtn = this.root.querySelector('[data-napa-nav="next"]');
    if (nextBtn) nextBtn.style.display = current === 'review' ? 'none' : '';

    this.renderSummary();
    if (current === 'review') this.renderReview();

    this.firstRender = false;
    this.save();
  };

  NapaKit.prototype.renderGroups = function () {
    var self = this;
    this.root.querySelectorAll('[data-napa-group]').forEach(function (group) {
      var picked = group.querySelectorAll('.napa-kit__card.is-selected').length;
      var badge = group.querySelector('[data-napa-group-picked]');

      if (badge) {
        badge.textContent = picked > 0 ? picked + ' in your kit' : '';
        badge.hidden = picked === 0;
      }
      group.classList.toggle('has-picks', picked > 0);

      if (self.firstRender && picked > 0) group.open = true;
    });
  };

  NapaKit.prototype.renderMessageField = function () {
    var wrap = this.root.querySelector('[data-napa-message-field]');
    if (!wrap) return;
    var opts = this.messageOptions();
    wrap.hidden = opts.length === 0;
    var hint = wrap.querySelector('[data-napa-message-hint]');
    if (hint && opts.length) {
      hint.textContent = 'Up to 400 characters. This is what we print on your ' +
        opts.map(function (o) { return o.label.toLowerCase(); }).join(' and ') + '.';
    }
  };

  NapaKit.prototype.renderMeter = function (cap, used) {
    var meter = this.root.querySelector('[data-napa-meter]');
    if (!meter) return;
    if (cap === 0) { meter.hidden = true; return; }
    meter.hidden = false;

    var box = this.optionById('box', this.state.box);
    var remaining = Math.max(0, cap - used);
    var pct = Math.min(100, Math.round((used / cap) * 100));

    var text = meter.querySelector('[data-napa-meter-text]');
    var count = meter.querySelector('[data-napa-meter-count]');
    var fill = meter.querySelector('[data-napa-meter-fill]');

    if (text) {
      text.textContent = remaining === 0
        ? (box ? box.label : 'This box') + ' is full'
        : plural(remaining, 'slot') + ' left in the ' + (box ? box.label : 'box');
    }
    if (count) count.textContent = used + ' / ' + cap;
    if (fill) fill.style.width = pct + '%';
    meter.classList.toggle('is-full', remaining === 0);
    meter.classList.toggle('is-over', used > cap);
  };

  NapaKit.prototype.renderSummary = function () {
    var self = this;
    var list = this.root.querySelector('[data-napa-lines]');
    if (!list) return;

    var lines = this.lines();
    list.innerHTML = '';

    if (!lines.length) {
      var empty = document.createElement('li');
      empty.className = 'napa-kit__lines-empty';
      empty.textContent = 'Nothing selected yet.';
      list.appendChild(empty);
    } else {
      lines.forEach(function (line) {
        var li = document.createElement('li');
        if (line.base) li.classList.add('napa-kit__line--base');
        if (line.fee) li.classList.add('napa-kit__line--fee');

        var labelCell = document.createElement('span');
        var tip = self.fillLabelCell(labelCell, line.label, line.description);
        li.appendChild(labelCell);

        var amountCell = document.createElement('span');
        amountCell.textContent = line.amount === 0 ? 'Included' : money(line.amount, self.symbol);
        li.appendChild(amountCell);

        if (tip) li.appendChild(tip);
        list.appendChild(li);
      });
    }

    var perKit = this.root.querySelector('[data-napa-perkit]');
    if (perKit) perKit.textContent = money(this.perKit(), this.symbol);

    var feeWrap = this.root.querySelector('[data-napa-fee-lines]');
    if (feeWrap) {
      var feeLines = this.orderFeeLines();
      feeWrap.innerHTML = '';
      if (!feeLines.length) {
        feeWrap.hidden = true;
      } else {
        feeWrap.hidden = false;
        var rows = [{ label: this.subtotalLabel, amount: this.kitsSubtotal(), subtotal: true }].concat(feeLines);
        rows.forEach(function (row) {
          var li = document.createElement('li');
          if (row.subtotal) li.classList.add('napa-kit__fee--subtotal');

          var text = row.basis === 'Percentage' ? row.label + ' (' + row.rate + '%)' : row.label;
          var labelCell = document.createElement('span');
          var tip = self.fillLabelCell(labelCell, text, row.description);
          li.appendChild(labelCell);

          var amountCell = document.createElement('span');
          amountCell.textContent = money(row.amount, self.symbol);
          li.appendChild(amountCell);

          if (tip) li.appendChild(tip);
          feeWrap.appendChild(li);
        });
      }
    }

    var total = this.root.querySelector('[data-napa-total]');
    if (total) total.textContent = money(this.total(), this.symbol);
  };

  /* ---------- review thumbnails ----------
     Review is the error-catching screen: its job is "that is not the box I
     picked". Names alone make that hard, so the kit block leads with a strip of
     thumbnails. Deliberately NOT added to the summary rail, which is 340px of
     price ledger and would become a cluttered list.

     Three fallbacks, in order: photo, then the entry's swatch colour (crinkle
     and ribbon are swatches with no photo), then a lettered tile. A strip with
     holes in it is worse than no strip. */

  NapaKit.prototype.thumb = function (label, image, swatch, qty) {
    var fig = document.createElement('figure');
    fig.className = 'napa-kit__thumb';

    var frame = document.createElement('span');
    frame.className = 'napa-kit__thumb-img';

    if (image) {
      var img = document.createElement('img');
      img.src = image;
      img.alt = '';
      img.loading = 'lazy';
      frame.appendChild(img);
    } else if (swatch && HEX.test(swatch)) {
      frame.classList.add('napa-kit__thumb-img--swatch');
      frame.style.background = swatch;
    } else {
      frame.classList.add('napa-kit__thumb-img--initial');
      frame.textContent = String(label || '?').trim().charAt(0).toUpperCase();
    }

    if (qty && qty > 1) {
      var badge = document.createElement('em');
      badge.className = 'napa-kit__thumb-qty';
      badge.textContent = 'x' + qty;
      frame.appendChild(badge);
    }

    fig.appendChild(frame);

    var cap = document.createElement('figcaption');
    cap.textContent = label;
    fig.appendChild(cap);
    return fig;
  };

  NapaKit.prototype.thumbStrip = function () {
    var self = this;
    var s = this.state;
    var items = [];

    var box = s.box ? this.optionById('box', s.box) : null;
    if (box) items.push({ label: box.label, image: box.image, swatch: box.swatch });

    var crinkle = s.crinkle ? this.optionById('crinkle', s.crinkle) : null;
    if (crinkle) items.push({ label: crinkle.label + ' crinkle', image: crinkle.image, swatch: crinkle.swatch });

    var ribbon = s.ribbon ? this.optionById('ribbon', s.ribbon) : null;
    if (ribbon) items.push({ label: ribbon.label + ' ribbon', image: ribbon.image, swatch: ribbon.swatch });

    Object.keys(s.contents).forEach(function (k) {
      var c = s.contents[k];
      var addon = self.addonByHandle(c.addonHandle);
      items.push({
        label: c.title + (c.variantTitle ? ' (' + c.variantTitle + ')' : ''),
        image: addon ? addon.image : null,
        qty: c.qty
      });
    });

    Object.keys(s.finishing).forEach(function (id) {
      if (!s.finishing[id]) return;
      var f = self.optionById('finishing', id);
      if (f) items.push({ label: f.label, image: f.image, swatch: f.swatch });
    });

    if (!items.length) return null;

    var wrap = document.createElement('div');
    wrap.className = 'napa-kit__thumbs';
    items.forEach(function (it) {
      wrap.appendChild(self.thumb(it.label, it.image, it.swatch, it.qty));
    });
    return wrap;
  };

  NapaKit.prototype.renderReview = function () {
    var self = this;
    var target = this.root.querySelector('[data-napa-review]');
    if (!target) return;
    var s = this.state;
    var box = s.box ? this.optionById('box', s.box) : null;
    var crinkle = s.crinkle ? this.optionById('crinkle', s.crinkle) : null;
    var ribbon = s.ribbon ? this.optionById('ribbon', s.ribbon) : null;
    var finishing = Object.keys(s.finishing).filter(function (k) { return s.finishing[k]; }).map(function (k) {
      var o = self.optionById('finishing', k); return o ? o.label : k;
    });
    var contents = Object.keys(s.contents).map(function (k) {
      var c = s.contents[k];
      return c.title + (c.variantTitle ? ' (' + c.variantTitle + ')' : '') + ' x' + c.qty;
    });

    function block(title, stepName, rows) {
      var visible = rows.filter(function (r) { return r[1]; });
      var el = document.createElement('div');
      el.className = 'napa-kit__review-block';
      el.innerHTML = '<h4></h4><dl>' + visible.map(function () { return '<dt></dt><dd></dd>'; }).join('') +
        (stepName ? '</dl><button type="button" class="napa-kit__review-edit" data-napa-edit="' + stepName + '">Edit</button>' : '</dl>');
      el.querySelector('h4').textContent = title;
      var dts = el.querySelectorAll('dt');
      var dds = el.querySelectorAll('dd');
      visible.forEach(function (r, i) { dts[i].textContent = r[0]; dds[i].textContent = r[1]; });
      return el;
    }

    var cap = this.capacity();
    target.innerHTML = '';

    var kitBlock = block('The kit', 'box', [
      ['Box', box ? box.label : 'Not selected'],
      ['Crinkle', crinkle ? crinkle.label : 'Not selected'],
      ['Inside', contents.join(', ') || 'Nothing selected'],
      ['Space used', cap > 0 ? this.usedSlots() + ' of ' + cap + ' slots' : ''],
      ['Ribbon', ribbon ? ribbon.label : 'Not selected'],
      ['Finishing touches', finishing.join(', ') || 'None']
    ]);

    /* Strip sits between the heading and the text rows: a glance first, the
       readable detail underneath. */
    var strip = this.thumbStrip();
    if (strip) kitBlock.insertBefore(strip, kitBlock.querySelector('dl'));
    target.appendChild(kitBlock);

    var pricingRows = [
      ['Price per kit', money(this.perKit(), this.symbol)],
      ['Quantity', s.kits + ' kits'],
      [this.subtotalLabel, money(this.kitsSubtotal(), this.symbol)]
    ];
    this.orderFeeLines().forEach(function (f) {
      pricingRows.push([f.basis === 'Percentage' ? f.label + ' (' + f.rate + '%)' : f.label, money(f.amount, self.symbol)]);
    });
    pricingRows.push(['Estimated total', money(this.total(), this.symbol)]);
    target.appendChild(block('Estimate', null, pricingRows));

    target.appendChild(block('Personalization', 'personalize', [
      ['For', s.personalize.recipientName],
      ['Gift message', s.personalize.message],
      ['Notes', s.personalize.notes]
    ]));
    target.appendChild(block('Delivery', 'delivery', [
      ['Delivery date', s.delivery.shipDate ? humanDate(s.delivery.shipDate) : ''],
      ['Area', 'Local delivery in Napa'],
      ['Address', s.delivery.address],
      ['Notes', s.delivery.notes]
    ]));
    target.appendChild(block('Contact', 'contact', [
      ['Name', s.contact.name],
      ['Company', s.contact.company],
      ['Email', s.contact.email],
      ['Phone', s.contact.phone]
    ]));
  };

  /* ---------- submission ---------- */

  NapaKit.prototype.optionPayload = function (role, id) {
    var o = id ? this.optionById(role, id) : null;
    if (!o) return null;
    return { handle: o.id, name: o.label, tier: o.tier, surcharge: this.surcharge(o) };
  };

  NapaKit.prototype.payload = function () {
    var self = this;
    var s = this.state;
    var box = s.box ? this.optionById('box', s.box) : null;

    var perKitFees = this.activeFees('Per kit').map(function (f) {
      return { handle: f.id, name: f.label, basis: 'Per kit', rate: null, amountPerKit: round2(parseFloat(f.amount) || 0), amount: round2((parseFloat(f.amount) || 0) * s.kits) };
    });
    var orderFees = this.orderFeeLines().map(function (f) {
      return { handle: f.handle, name: f.label, basis: f.basis, rate: f.rate, amount: f.amount };
    });

    return {
      submittedAt: new Date().toISOString(),
      source: 'napa-kit-builder',
      pageUrl: window.location.href,
      kitQuantity: s.kits,
      baseKitPrice: this.basePrice,
      pricePerKit: round2(this.perKit()),
      kitsSubtotal: round2(this.kitsSubtotal()),
      fees: perKitFees.concat(orderFees),
      feesTotal: round2(perKitFees.concat(orderFees).reduce(function (t, f) { return t + f.amount; }, 0)),
      estimatedTotal: round2(this.total()),
      currency: this.root.dataset.currency || 'USD',
      slotsUsed: this.usedSlots(),
      slotCapacity: this.capacity(),
      deliveryArea: 'Napa local delivery',
      leadTimeDays: this.leadDays,
      earliestAllowedDate: this.earliestDate,
      leadTimeTimezone: this.timezone,
      box: box ? { handle: box.id, name: box.label, tier: box.tier, color: box.color || null, size: box.size || null, capacity: box.capacity || null, surcharge: this.surcharge(box) } : null,
      crinkle: this.optionPayload('crinkle', s.crinkle),
      ribbon: this.optionPayload('ribbon', s.ribbon),
      finishingTouches: Object.keys(s.finishing).filter(function (k) { return s.finishing[k]; }).map(function (k) {
        return self.optionPayload('finishing', k);
      }),
      contents: Object.keys(s.contents).map(function (k) {
        var c = s.contents[k];
        return {
          addonHandle: c.addonHandle,
          name: c.title,
          variant: c.variantTitle || null,
          productId: c.productId,
          variantId: c.variantId,
          quantity: c.qty,
          unitPrice: c.price,
          slotsEach: c.slots
        };
      }),
      personalization: s.personalize,
      delivery: s.delivery,
      contact: s.contact
    };
  };

  NapaKit.prototype.submit = function () {
    var self = this;
    var blocking = null;
    ['box', 'crinkle', 'contents', 'ribbon', 'personalize', 'delivery', 'contact'].forEach(function (st) {
      if (!blocking && self.validate(st)) blocking = st;
    });
    if (blocking) {
      this.showError(this.validate(blocking));
      this.goTo(STEPS.indexOf(blocking));
      return;
    }

    var status = this.root.querySelector('[data-napa-status]');
    var btn = this.root.querySelector('[data-napa-submit]');
    var data = this.payload();

    if (!this.endpoint) {
      var fb = this.root.querySelector('[data-napa-fallback]');
      if (fb) { fb.value = JSON.stringify(data, null, 2); fb.classList.add('is-visible'); }
      if (status) status.textContent = 'No submission endpoint is configured yet. The request payload is shown below for testing.';
      console.warn('[napa-kit] no endpoint configured. Payload:', data);
      return;
    }

    if (btn) btn.disabled = true;
    if (status) status.textContent = 'Sending your kit request...';

    fetch(this.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(data)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      self.clearSaved();
      self.root.querySelector('[data-napa-main]').style.display = 'none';
      var done = self.root.querySelector('[data-napa-done]');
      if (done) done.classList.add('is-active');
      if (window.dataLayer) window.dataLayer.push({ event: 'napa_kit_request', kit_quantity: data.kitQuantity, estimated_total: data.estimatedTotal });
    }).catch(function (err) {
      console.error('[napa-kit] submit failed', err);
      if (btn) btn.disabled = false;
      if (status) {
        status.textContent = 'Something went wrong sending your request.' + (self.fallbackEmail ? ' Please email ' + self.fallbackEmail + ' and we will pick it up from there.' : '');
      }
    });
  };

  function init() {
    document.querySelectorAll('[data-napa-kit]').forEach(function (el) {
      if (!el.napaKit) el.napaKit = new NapaKit(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
